import { Order } from "../../../types";
import { SourceSortAscIcon, SourceSortDescIcon } from "../../images";
import { Stack } from "@mui/material";
import { EllipsisTooltip } from "../../ui/CustomTooltip";
import { TextWrapper } from "./TextWrapper";

export const DataSourceHeaderCell = ({
  id,
  value,
  tooltip,
  isSelected,
  order,
  clickHandler,
  minWidth,
  maxWidth,
  justifyContent = "flex-end",
  gap = "8px",
}: {
  id: string;
  value: string;
  tooltip?: string;
  isSelected: boolean;
  order?: string;
  clickHandler: (key: string) => void;
  minWidth: string;
  maxWidth: string;
  justifyContent?: "space-between" | "center" | "flex-start" | "flex-end";
  gap?: string;
}) => {
  return (
    <Stack
      onClick={() => clickHandler(id)}
      flexDirection="row"
      alignItems="center"
      minWidth={minWidth}
      maxWidth={maxWidth}
      justifyContent={justifyContent}
      width="100%"
      gap={gap}
      padding="0 16px"
      sx={{
        cursor: "pointer",
        "&:hover": {
          opacity: 0.8,
        },
      }}
    >
      <EllipsisTooltip tooltip={tooltip} align="center">
        <TextWrapper isHighlighted={true} text={value} />
      </EllipsisTooltip>

      {isSelected && order === Order.ASC ? (
        <SourceSortAscIcon />
      ) : (
        <SourceSortDescIcon />
      )}
    </Stack>
  );
};
